import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../../feature'
import { getEdgeDataDefinition, getNodeDataDefinition } from '../elements'
import type { Manager } from '../manager'

export const addNodeToCytoscape = store.effects.create(
  (feature: Feature, manager: Manager) =>
    feature.actions.addNode.observe().pipe(
      rxjs.map(({ data: { node, parentId, orgChartId } }) => {
        const cy = manager.getInstance({ orgChartId })
        if (!cy) {
          return
        }
        cy.add({ data: getNodeDataDefinition(node) })
        if (parentId) {
          cy.add({
            data: getEdgeDataDefinition({ childId: node.id, parentId }),
          })
        }
        manager.resetLayout({ orgChartId })
      }),
      rxjs.ignoreElements(),
    ),
)
